const defaultColors = [
    { name: 'Black', color: '#000' },
    { name: 'White', color: '#fff' },
    { name: 'Cyan bluish gray', color: '#eee' },
    { name: 'Pale cyan blue', color: '#8ed1fc' },
    { name: 'Pale pink', color: '#f78da7' },
    { name: 'Vivid cyan blue', color: '#0693e3' },
];

export default defaultColors;